import { Link } from "react-router-dom";

const formatMoney = (value) => {
  const amount = Number(value || 0);
  if (!amount) return null;
  return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(amount);
};

const PublicJobCard = ({ job }) => {
  const companyInitials = String(job?.company?.name || job?.title || "JP")
    .split(" ")
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const minSal = formatMoney(job?.salary?.minimum);
  const maxSal = formatMoney(job?.salary?.maximum);
  const salaryLabel =
    minSal || maxSal
      ? `INR ${minSal || "NA"} - INR ${maxSal || "NA"}`
      : "Salary not disclosed";

  const expMin = job?.experience?.minimum ?? 0;
  const expMax = job?.experience?.maximum ?? 0;
  const expLabel = `${expMin}-${expMax} years experience`;
  const postedOn = job?.createdAt ? new Date(job.createdAt).toLocaleDateString() : null;

  return (
    <div className="portal-card h-100 d-flex flex-column">
      <div className="portal-card-body d-flex flex-column h-100">
        <div className="portal-job-card-header">
          <div className="d-flex align-items-center gap-3">
            <span
              aria-hidden="true"
              style={{
                alignItems: "center",
                background: "#f6f3f2",
                borderRadius: 8,
                color: "#ad2b16",
                display: "inline-flex",
                fontSize: "0.9rem",
                fontWeight: 800,
                height: 44,
                justifyContent: "center",
                minWidth: 44,
              }}
            >
              {companyInitials}
            </span>
            <div className="portal-badge">
              {(job?.employmentType || "Full time").replaceAll("_", " ")}
            </div>
          </div>
          <span className="portal-pill text-uppercase" style={{ fontSize: "10px" }}>
            {job?.workMode || "Onsite"}
          </span>
        </div>

        <Link to={`/jobs/${job?.id}`} className="portal-job-title mt-2 mb-1">
          {job?.title}
        </Link>

        <div className="portal-job-meta">
          <span>{job?.company?.name || "Premium Company"}</span>
          <span className="opacity-50">|</span>
          <span>{job?.location?.display || "India"}</span>
        </div>

        <div className="portal-job-tags">
          <span className="portal-pill">{salaryLabel}</span>
          <span className="portal-pill">{expLabel}</span>
          {job?.qualification ? <span className="portal-pill">{job.qualification}</span> : null}
        </div>

        {job?.description ? (
          <p
            className="text-muted small mb-4"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {job.description}
          </p>
        ) : null}

        <div className="portal-job-footer mt-auto">
          <span className="small text-muted">
            {postedOn ? `Posted ${postedOn}` : "Actively hiring"}
          </span>
          <Link
            to={`/jobs/${job?.id}`}
            className="portal-btn-primary py-1 px-3"
            style={{ fontSize: "0.8rem" }}
          >
            View role
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PublicJobCard;
